import { showErrorSnackbar } from 'components/shared/Snackbar';
import { useGetAdminSettings } from '../../../../queries';
import { AdminSettingsResponse } from '../../../types';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import {
  getImportEmployeeConfig,
  getImportEmployeeConfigEmployer
} from 'RestAPIs/admin';
import { ImportEmployeeSetting } from './types';

export const SETTINGS_GROUP_IMPORT_EMPLOYEE = `import-employee`;

export const useGetGeneralTableData = () => {
  const { t } = useTranslation('common');

  const { data = [], isFetching } = useGetAdminSettings<AdminSettingsResponse>(
    SETTINGS_GROUP_IMPORT_EMPLOYEE,
    {
      onError: () => showErrorSnackbar(t('onError'))
    }
  );

  return { tableData: data, isFetching };
};

export const useGetConnectionTableData = (): {
  isFetching: boolean;
  connectionTable: ImportEmployeeSetting[];
} => {
  const { data, isFetching } = useQuery(['importEmployeeConfig'], async () => {
    const { data } = await getImportEmployeeConfig();
    return data;
  });

  return { isFetching, connectionTable: data ?? [] };
};

export const useGetImportEmployeeConfigEmployer = () => {
  const { data, isFetching } = useQuery(
    ['importEmployeeConfigEmployer'],
    async () => {
      const { data } = await getImportEmployeeConfigEmployer();
      return data.map((item) => {
        return {
          ...item,
          employerId: item.brEmployerId
        };
      });
    }
  );
  return { data, isFetching };
};
